<!-- <div class="row mt-3 sr-only" *ngIf="contact.dpa_companytypeid == null || contact.dpa_companytypeid == ''">
  <div class="col-2 text-right">
    <label class="">ประเภทบุคคล</label>
  </div>
  <div class="col-3">
    <select class="form-control" [(ngModel)]="contact.dpa_personaltypeid">
    <option value="">เลือก</option>
    <option *ngFor="let p of personalTypeList" [value]="p.dpa_personaltypeid">
      {{p.dpa_name}}
    </option>
  </select>
  </div>

  <div class="row mt-3" *ngIf="contact.dpa_companytypeid">
    <div class="col-2 text-right">
      <label class="">ประเภทนิติบุคคล</label>
    </div>
    <div class="col-3">
      <select class="form-control" [(ngModel)]="contact.dpa_companytypeid">
      <option value="">เลือก</option>
      <option *ngFor="let p of companyTypeList" [value]="p.dpa_companytypeid">
        {{p.dpa_name}}
      </option>
    </select>
    </div>
  </div>
</div> -->

<div class="row mt-3">
  <div class="col-2 text-right">
    <label class="">ชื่อ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.firstname}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label class="">นามสกุล</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.lastname}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>วันเดือนปีเกิด</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.birthdate | thaidate: 'short'}}" readonly>
  </div>
  <div class="col-2 text-right  two-row-lbl">
    <label class="">หมายเลขบัตรประชาชน/</label>
    <br>
    <label>เลขประจำตัวผู้เสียภาษี</label>
  </div>

  <div class="col-3" *ngIf="contact.dpa_companytypeid == null || contact.dpa_companytypeid == ''">
    <input type="text" class="form-control" value="{{contact.dpa_idcard}}" readonly>
  </div>
  <div class="col-3" *ngIf="contact.dpa_companytypeid != null && contact.dpa_companytypeid != ''">
    <input type="text" class="form-control" value="{{contact.dpa_registrationid}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label class="required">Email หลัก</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.emailaddress1" >
    <span class="text-danger" *ngIf="submitted && contact.emailaddress1.trim().length == 0">
      กรุณาระบุ Email หลัก
    </span><span class="text-danger" *ngIf="submitted && contact.emailaddress1.trim().length > 0 && !isValidMail(contact.emailaddress1)">
      กรุณาระบุ Email หลักให้ถูกต้อง
    </span>
  </div>
  <div class="col-2 text-right">
    <label class="required">หมายเลขโทรศัพท์</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.telephone1" >
    <span class="text-danger" *ngIf="submitted && contact.telephone1.trim().length == 0">
      กรุณาระบุ หมายเลขโทรศัพท์
    </span>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2">
    
  </div>
  <div class="col-8">
   <label class="ml-3">
     <input type="checkbox" [checked]="contact.dpa_allowemail" (change)="contact.dpa_allowemail = !contact.dpa_allowemail">
     ยินยอมให้ติดต่อผ่าน E-mail ที่ท่านแจ้งไว้
    </label>
   <label class="ml-3">
     <input type="checkbox" [checked]="contact.dpa_allowsms " (change)="contact.dpa_allowsms  = !contact.dpa_allowsms ">
     ยินยอมให้ติดต่อผ่านหมายเลขโทรศัพท์ที่ท่านแจ้งไว้
   </label>
   <label class="ml-3">
     <input type="checkbox" [checked]="contact.dpa_pdpa_flag " (change)="contact.dpa_pdpa_flag  = !contact.dpa_pdpa_flag ">
     ยอมรับนโยบายความเป็นส่วนตัว
   </label>
  </div>
  <div class="col-2">
    
  </div>
  <div class="col-2">
    
  </div>
  <div class="col-10">
    <button id="btnSend" class="btn btn-info m-2" (click)="sendMailPortal()">ยืนยันอีเมลลงทะเบียนใช้งาน Customer Web Portal</button>
  </div>
</div>

<hr class="mb-0">

<div class="row">
  <div class="col-2 section-label">
    <h6 class="m-0 ml-3">ที่อยู่ตามบัตรประชาชน</h6>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>เลขที่</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.dpa_registration_homeno}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label>ถนน</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.dpa_registration_street}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>หมู่ที่</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.dpa_registration_moo}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label>แขวง/ตำบล</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.dpa_registration_subdistictname}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>เขต/อำเภอ</label>
  </div>
  <div class="col-3">
      <input type="text" class="form-control" value="{{contact.dpa_registration_distictname}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label>จังหวัด</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.dpa_registration_provincename}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>รหัสไปรษณีย์</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.dpa_registration_postcodename}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label>ประเทศ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.dpa_registration_countryname}}" readonly>
  </div>
</div>

<hr class="mb-0">
<div class="row">
  <div class="col-2 section-label">
    <h6 class="m-0 ml-3">ที่อยู่ที่สามารถติดต่อได้</h6>
  </div>
</div>

<div class="row">
  <div class="col-6 offset-md-2">
    <label>
    <input type="checkbox" (click)="CopyAddress($event)">
    เหมือนกับที่อยู่ตามบัตรประชาชน
    </label>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label class="">เลขที่</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_homeno">
  </div>
  <div class="col-2 text-right">
    <label>ถนน</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_street">
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>หมู่ที่</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_moo">
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label class="">ที่อยู่</label>
  </div>
  <div class="col-3">
    <select class="form-control select2">
      <option value="">เลือก</option>
      <option *ngFor="let sd of combinedAddressList" [value]="sd.id">
        {{sd.text}}
      </option>
    </select>
  </div>

  <div class="col-2 text-right">
    <label class="">แขวง/ตำบล</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.dpa_contact_subdistictname}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label class="">เขต/อำเภอ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.dpa_contact_distictname}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label class="">จังหวัด</label>
  </div>
  <div class="col-3">
      <input type="text" class="form-control" value="{{contact.dpa_contact_provincname}}" readonly>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right" readonly>
    <label class="">รหัสไปรษณีย์</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" value="{{contact.dpa_contact_postcodename}}" readonly>
  </div>
  <div class="col-2 text-right">
    <label class="">ประเทศ</label>
  </div>
  <div class="col-3">
    <select class="form-control" [(ngModel)]="contact.dpa_contact_country">
      <option value="">เลือก</option>
      <option *ngFor="let country of countryList" [value]="country.dpa_countryid" >
        {{country.dpa_name}}
      </option>
    </select>
  </div>
</div>

<div class="row mt-5 mb-3">
  <div class="col-12 text-center">
    <button class="btn btn-info m-2" (click)="displayPopup()">บันทึก</button>
    <!-- <button class="btn btn-info m-2">ล้างข้อมูล</button> -->
    <button class="btn btn-info m-2" (click)="close()">ปิด</button>
  </div>
</div>



<!-- Modal detail-->
<div class="modal" [ngStyle]="{'display':displayStyle}"aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-m">
    <div class="modal-content">

      <div class="modal-body" [formGroup]="form" style="background-color: #a7c4e6">

        <div class="row mt-3">
          <div class="col-12 text-center">
            <h5 class="modal-title" style="font-weight: bold">Supervisor Authorization</h5>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-3 offset-md-1 text-right">
            <label class="font-weight-bold">Email :</label>
          </div>
          <div class="col-6">
            <input type="text" class="form-control" name="email" placeholder="Email" formControlName="email">
          </div>
        
        </div>
        <div class="row mt-3">
          <div class="col-2 offset-md-1 text-right">
            
          </div>
          <div class="col-6 text-left">
            <span class="text-danger ml-5"
            *ngIf="(formControl.email.touched || submitted) && formControl.email.errors?.required">
            กรุณาระบุ Email
          </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6 text-right">
            <button class="btn btn-primary" (click)="authorize()">
              ยืนยัน
            </button>
          </div>
          <div class="col-6 text-left">
            <button type="button" class="btn btn-info" (click)="closePop()">ปิด</button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3 text-center">
           &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--<div class="modal" [ngStyle]="{'display':displayStyle}"aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-m">
    <div class="modal-content">

      <div class="modal-body" [formGroup]="form" style="background-color: #a7c4e6">

        <div class="row mt-3">
          <div class="col-12 text-center">
            <h5 class="modal-title" style="font-weight: bold">Supervisor Authorization</h5>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-3 offset-md-1 text-right">
            <label class="font-weight-bold">Username :</label>
          </div>
          <div class="col-6">
            <input type="text" class="form-control" name="username" placeholder="Username" formControlName="username">
          </div>
        
        </div>
        <div class="row mt-3">
          <div class="col-2 offset-md-1 text-right">
            
          </div>
          <div class="col-6 text-left">
            <span class="text-danger ml-5"
            *ngIf="(formControl.username.touched || submitted) && formControl.username.errors?.required">
            กรุณาระบุ Username
          </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3 offset-md-1 text-right">
            <label class="font-weight-bold">Password :</label>
          </div>
          <div class="col-6">
            <input type="password" class="form-control" name="Password" placeholder="Password" formControlName="password">
          </div>
         
        </div>
        <div class="row mt-3">
          <div class="col-2 offset-md-1 text-right">
            
          </div>
          <div class="col-6 text-left">
            <span class="text-danger ml-5"
            *ngIf="(formControl.password.touched || submitted) && formControl.password.errors?.required">
            กรุณาระบุ Password
          </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6 text-right">
            <button class="btn btn-primary" (click)="authorize()">
              ยืนยัน
            </button>
          </div>
          <div class="col-6 text-left">
            <button type="button" class="btn btn-info" (click)="closePop()">ปิด</button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3 text-center">
           &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</div>-->


// WEBPACK FOOTER //
// ./src/app/customer-detail/customer-detail.component.html